import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';

import LogoImage from '@app/components/LogoImage';
import { Modal } from '@app/components/ui/Modal';
import { useCommonData } from '@app/hooks/useCommonData';
import { cn } from '@app/libs/utils';

type VerifyModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  title?: string | React.ReactNode;
  message?: string | React.ReactNode;
};

export default function VerifyModal({
  isOpen: isOpenProp,
  title = 'Yêu cầu xác thực tài khoản',
  message = (
    <>
      Tài khoản của bạn chưa được xác thực. <br /> Vui lòng thực hiện xác thực trên ứng dụng PropX.
    </>
  ),
  onClose,
}: VerifyModalProps) {
  const { verifyApp } = useCommonData();
  const qrCodeContent = {
    'App Store': verifyApp.appStoreUrl,
    'CH Play': verifyApp.playStoreUrl,
  };
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(isOpenProp);
  }, [isOpenProp]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
        onClose?.();
      }}
      showCloseButton
      size="lg"
      position="center"
      animation="zoom"
      contentClassName="bg-white rounded-lg border border-gray-200"
      className="p-6"
    >
      <div className="flex flex-col items-center gap-10">
        <div className="flex items-center justify-center">
          <LogoImage variant="icon" size="md" />
        </div>

        {/* Title */}
        <h3 className="text-2xl font-semibold text-black text-center">{title}</h3>

        {/* Body */}
        <p className="text-md text-black text-center whitespace-pre-line">{message}</p>

        <p className="text-[15px] leading-[24px] text-black text-center whitespace-pre-line">
          Tải ứng dụng tại:
        </p>

        {/* Store links (layout tham khảo từ Figma) */}
        <div className="flex items-center gap-16 mt-2 justify-stretch">
          {Object.entries(qrCodeContent).map(([key, value]) => (
            <Link
              href={value}
              key={key}
              className={cn(
                'flex flex-col items-center gap-2',
                'hover:opacity-80 transition-all',
                `w-1/${Object.entries(qrCodeContent).length}`
              )}
            >
              <Image
                src={`/api/v1/qrcode?data=${value}&size=240`}
                width={240}
                height={240}
                alt={key}
                className="w-full h-full"
              />
              <span className="text-[15px] leading-[24px] text-black">{key}</span>
            </Link>
          ))}
        </div>

        {/* Action row: Close */}
        <div className="w-full flex justify-center mt-4">
          <button
            onClick={() => {
              setIsOpen(false);
              onClose?.();
            }}
            className="inline-flex items-center justify-center h-10 px-4 rounded-md bg-blue-500 text-white text-sm font-medium"
          >
            Đóng
          </button>
        </div>
      </div>
    </Modal>
  );
}
